module.exports = __webpack_public_path__ + "img/analysis_revise_left.94742ce7.svg";